export default {
	"name": "ThaliaChat",
	"stage": "produktion",
	"mandanten": ["2", "2003"],
	"pagetypes": "all",
	"excludedPagetypes": ["login", "bestelluebersicht"],
	"requiresConsent": false,
	"serviceSettings": {
		"2": {
			"jspUrl": "https://chat.thalia.de/chatRest",
			"frontendId": "frontend-thalia",
			"scriptSrc": "https://ecdn.novomind.com/rules/la/nm.rules.js"
		},
		"2003": {
			"jspUrl": "https://chat.thalia.de/chatRest",
			"frontendId": "frontend-thalia-app",
			"scriptSrc": "https://ecdn.novomind.com/rules/la/nm.rules.js"
		}
	}
}
